import * as React from 'react';

import { NoResultsFound } from '@/components/common';
import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import AuthorPageLayout from '@/components/pages/author/layout/author-page-layout';
import { ArticleType } from '@/types/article-type';
import { AuthorEndpointResult } from '@/utils/functions/wordpress/fetch-author';

export interface AuthorPageControllerProps {
    author: AuthorEndpointResult;
    articles: ArticleType[];
}

const AuthorPageController = ({ author, articles }: AuthorPageControllerProps) => {
    if (!author) {
        // todo: redirect to 404?
        return (
            <NoResultsFound
                title="Something Went Wrong"
                description="Please try again later."
                className="min-h-[350px]"
            />
        );
    }

    return <AuthorPageLayout author={author} articles={articles} />;
};

export default withExceptionCatcher(AuthorPageController);
